import dayjs from 'shared/helpers/dayjs';
import { UrgencyStatistic } from 'dashboard/hooks/useUrgencyStatistics';

export default function aggregateByWeek(
  data: UrgencyStatistic[]
): UrgencyStatistic[] {
  const grouped = new Map<string, UrgencyStatistic>();
  data.forEach((item) => {
    const weekStart = dayjs(item.date).startOf('isoWeek').format('YYYY-MM-DD');
    const existing = grouped.get(weekStart);
    if (existing) {
      existing.emergency += item.emergency;
      existing.needs_attention += item.needs_attention;
      existing.routine += item.routine;
      existing.informational += item.informational;
    } else {
      grouped.set(weekStart, { ...item, date: weekStart });
    }
  });
  return Array.from(grouped.values());
}
